import React from "react";
import { Box, Typography, Paper } from "@material-ui/core";

function AboutReadinessTab({ }) {
    return (
        <Box display="flex" justifyContent="center" width="100%">
            <Paper
                elevation={0}
                style={{
                    maxWidth: 1300,
                    minHeight: 510,
                    width: "100%",
                    margin: "0 auto",
                    borderRadius: 12,
                    background: "#fff",
                    padding: "40px 36px 32px 36px",
                }}
            >
                <Typography style={{ marginBottom: 18 }}>
                    The AI Readiness Assessment for Schools is designed to evaluate students' AI readiness (ages 8–18) within your educational institution. It provides comprehensive insights into students' competencies with AI, digital media, and technology, enabling educators and school leaders to effectively support and enhance these essential skills.
                </Typography>
                <Typography style={{ marginBottom: 18 }}>
                    The assessment includes an integrated summary derived from seven targeted surveys, focusing on these critical areas:
                </Typography>
                <Box component="ul" pl={3} mb={4} style={{ marginTop: 0 }}>
                    <li>
                        <b>AIR1:</b> Digital Engagement and Adoption Index – Evaluates students' level and nature of digital engagement and technology adoption.
                    </li>
                    <li>
                        <b>AIR2:</b> Youth Cyber Safety Index – Assesses students' behaviors and practices related to maintaining online safety.
                    </li>
                    <li>
                        <b>AIR3:</b> Digital Literacy Skills Index – Measures core digital literacy skills necessary for students to navigate digital environments safely and responsibly.
                    </li>
                    <li>
                        <b>AIR4:</b> AI Essential Skills Index – Reviews foundational skills required for using and understanding artificial intelligence tools.
                    </li>
                    <li>
                        <b>AIR5:</b> Youth Perceived Digital Support Index – Captures students' perceptions of the digital support provided by educators, parents, and caregivers.
                    </li>
                    <li>
                        <b>AIR6:</b> Digital Parenting Index – Evaluates parental competencies and readiness in supporting students’ digital and AI engagement.
                    </li>
                    <li>
                        <b>AIR7:</b> School AI Readiness Index – Analyzes your school's readiness and capacity to integrate and effectively support AI and digital literacy education.
                    </li>
                </Box>

                <Typography style={{ marginBottom: 18 }}>
                    Your school has completed the following assessment(s). This report summarizes your students' overall scores and compares them against national and global benchmarks, providing strategic insights into how your school is performing relative to these independent standards. Recommendations are included to enhance students' readiness to use digital technology safely, responsibly, and effectively, supporting their academic success and overall well-being.
                </Typography>

                <Typography style={{ margin: "32px 0 0 0", fontWeight: 600 }}>
                    Completed Assessment:
                </Typography>
                <Typography style={{ marginTop: 2 }}>
                    • AIR1: Digital Engagement and Adoption Index
                </Typography>
            </Paper>
        </Box>
    );
}

export default AboutReadinessTab;